import React from 'react';
import PodToolRootPage from '../calculator-tool/root-page';

function StoryblokPodToolRootPage(props) {
  return <PodToolRootPage {...props} />;
}

export default StoryblokPodToolRootPage;
